import {srcUrl} from "@/api/ImageApi.ts";
import question from "@assets/question.svg";
import {Character, CharacterSummary} from "@/characters/model/Character.ts";
import {getStyleColor} from "./model/ChallengeRating.ts";

export default function CharacterImage(
    {
        character,
        size,
    }: {
        character: Character | CharacterSummary,
        size: number,
    }) {

    const styleColor = getStyleColor(character);

    return (
        <div className={`flex-none bg-white overflow-hidden rounded-xs border-2 ${styleColor.border}`}
             style={{width: size, height: size}}>
            {character.image &&
                <img draggable="false" alt=""
                     className="size-full select-none object-contain"
                     src={srcUrl(character.image)}
                />}
            {!character.image &&
                <img draggable="false" alt=""
                     className={"size-full scale-90 select-none object-contain"}
                     src={question}/>}
        </div>
    )
}
